import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    items: [],
    filters: {
      order_by: 'created_at',
      order: 'DESC'
    },
    searchSubscriptionPricelist: {},
    balance: {}
  },
  mutations: {
    setItems (state, list) {
      state.items = list
    },
    setFilters (state, filter) {
      state.filters = { ...state.filters, ...filter }
    },
    setSearchSubscriptionPricelist (state, searchSubscriptionPricelist) {
      state.searchSubscriptionPricelist = { ...searchSubscriptionPricelist }
    },
    setBalance (state, balance) {
      state.balance = { ...balance }
    }
  },
  getters: {

  },
  actions: {
    getList ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getPaymentsList(token, state.filters)
            .then((res) => {
              commit('setItems', res.body.list)
              resolve(state.items)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    getSearchSubscriptionPricelist ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getSearchSubscriptionPricelist(token)
            .then((res) => {
              commit('setSearchSubscriptionPricelist', res.body)
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    newSearchSubscription ({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.newSearchSubscription(token, data)
            .then((res) => {
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    cancelSearchSubscription ({ dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.cancelSearchSubscription(token)
            .then((res) => {
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    getBalance ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getPaymentsBalance(token)
            .then((res) => {
              commit('setBalance', res.body)
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    withdraw ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.withdraw(token, data)
            .then((res) => {
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    pay ({ dispatch }, paymentId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.pay(token, paymentId)
            .then((res) => {
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
